import React from 'react';
import { TOKENS } from '../styles';

interface Props {
  label: string;
  count?: number;
}

export default function SectionHead({ label, count }: Props) {
  return (
    <div style={{
      fontSize: 13,
      fontWeight: 700,
      color: TOKENS.dark,
      letterSpacing: '0.6px',
      textTransform: 'uppercase',
      margin: '26px 0 10px',
      display: 'flex',
      alignItems: 'center',
      gap: 8,
    }}>
      {label}
      {count !== undefined && (
        <span style={{
          background: TOKENS.slateHead,
          color: 'white',
          borderRadius: 999,
          minWidth: 20,
          height: 20,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 11,
          padding: '0 6px',
          fontWeight: 700,
        }}>
          {count}
        </span>
      )}
    </div>
  );
}